import React from 'react';
import PropTypes from 'prop-types';

import {Box, ButtonBase, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

import {PERIOD_ROLES} from '../shared/periods';

const PERIOD_LABEL_EXPRESSIONS = {
  previous: 'metrics.ClientMetrics.ClientMonthly.Periods.Previous',
  current: 'metrics.ClientMetrics.ClientMonthly.Periods.Current',
  next: 'metrics.ClientMetrics.ClientMonthly.Periods.Next',
};

// Segmented control that switches which calendar month the client breakdown fetches. Each
// segment is a real toggle button with aria-pressed so the active month is announced.
const PeriodTabs = (props) => {
  const {
    value,
    onChange,
  } = props;

  return (
    <Box
      role='group'
      aria-label={translate('metrics.ClientMetrics.ClientMonthly.PeriodSelectorLabel')}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        p: 0.5,
        backgroundColor: '#EEEEEE',
        borderRadius: '8px',
      }}
    >
      {
        PERIOD_ROLES.map((role) => {
          const isActive = value === role;

          return (
            <ButtonBase
              key={role}
              onClick={() => onChange(role)}
              aria-pressed={isActive}
              sx={{
                px: 1.75,
                py: 0.75,
                borderRadius: '6px',
                backgroundColor: isActive ? '#FFFFFF' : 'transparent',
                boxShadow: isActive ? '0px 4px 4px rgba(0, 0, 0, 0.05)' : 'none',
              }}
            >
              <Typography
                sx={{
                  fontSize: '11px',
                  fontWeight: 500,
                  color: isActive ? '#000000' : '#6B6761',
                }}
              >
                <Translate expression={PERIOD_LABEL_EXPRESSIONS[role]} />
              </Typography>
            </ButtonBase>
          );
        })
      }
    </Box>
  );
};

PeriodTabs.propTypes = {
  value: PropTypes.oneOf(PERIOD_ROLES).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default React.memo(PeriodTabs);
